import { Injectable } from '@angular/core';
import { StorageService, StorageKey } from '../storage/storage.service';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonService } from '../common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor( private storageService: StorageService,
    private apiUrl: ApiUrlHelper,
    public commonService: CommonService,
    private spinner: NgxSpinnerService,
    private route : Router 
    ) { }

  logout() {
    const apiUrl = this.apiUrl.apiUrl.login.Logout;
    this.spinner.show();
    this.commonService.doPost(apiUrl,'').pipe().subscribe({
        next: async (response) => {
          if (response.success) {
            this.spinner.hide();
            localStorage.clear();
            // window.location.href ="/#/login";
            this.route.navigate(['/login'])
            
          }
        },
        error: (error) => {
        }
      });
  }

   isTokenExpired():boolean {
    let expireDate = this.storageService.getValue('expireDate');
    return new Date().getTime() > new Date(expireDate).getTime();
  }

  isLoggedIn(): boolean {
    let token = this.storageService.getValue('authToken');
    let currentUser = this.storageService.getValue('currentUserId');
    if (token && currentUser)
      return true;
    else
      return false;
  }

  getAccessToken(): any {
    let token = this.storageService.getValue(StorageKey.authToken);
    return token ? token : null;
  }

  getUserId(): any {
    let id = JSON.parse(this.storageService.getValue(StorageKey.currentUser)).id;
    return id ? id : null;
  }

  getUserName(): any {
    let name = JSON.parse(this.storageService.getValue(StorageKey.currentUser)).userName;
    return name ? name : null;
  }

  getUserFullName(): any {
    let name = JSON.parse(this.storageService.getValue(StorageKey.currentUser)).userFullName;
    return name ? name : null;
  }
  
  getAdminRoleId(): number {
    let adminRoleId = Number(this.storageService.getValue(StorageKey.adminRoleId));
    return adminRoleId ? adminRoleId : 0;
  }
}
